import apiClient from "../api/apiClient";

export interface PaginatedResponse<T> {
  status: boolean;
  data: T[];
  pagination: {
    current_page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
}

export interface UserReport {
  _id: string;
  reporter: { _id: string; user_name: string; profile_pic?: string | null };
  reportedUser: {
    _id: string;
    user_name: string;
    profile_pic?: string | null;
    role?: string;
  };
  reason: string;
  details: string;
  status: "pending" | "resolved" | "dismissed";
  resolvedBy?: string | null;
  resolvedAt?: string | null;
  createdAt: string;
}

export class UserReportAdminService {
  static async listReports(
    status = "",
    page = 1,
    limit = 20,
  ): Promise<PaginatedResponse<UserReport>> {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (status) params.append("status", status);
    const res = await apiClient.get(`/admin/user-reports?${params}`);
    return res.data;
  }

  static async resolveReport(id: string, action: "resolve" | "dismiss") {
    const res = await apiClient.put(`/admin/user-reports/${id}/resolve`, { action });
    return res.data;
  }
}

export default UserReportAdminService;
